function TabPanelTitle({ children }: { children: React.ReactNode }) {
  return (
    <div className="sticky top-0 w-full bg-white pt-2 text-xs lg:text-sm font-semibold">
      {children}
    </div>
  );
}

export default TabPanelTitle;
